import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import ButtonGroupProps from './ButtonGroupProps'


export default {
    props: ButtonGroupProps,
    render (h) {
        return h('ul',this.$slots.default)
    },
    mixins: [
        KendoBaseComponent
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoButtonGroup(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoButtonGroup()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButtonGroup/KendoButtonGroupMixin.js